import classNames from "classnames";
import RCSlider, { type SliderProps as RCSliderProps } from "rc-slider";
import React, { type ReactElement } from "react";

import "./style.less";

// TODO: try make it work with SliderWithCustomHandle
// const RCSlider = loadable(() => import(/* webpackChunkName: "rc-slider" */ "rc-slider"), {
//   fallback: <div style={{ padding: 16 }}>Loading...</div>
// });

type SliderBaseProps = RCSliderProps & {
  containerRef?: React.RefObject<HTMLDivElement | null>;
  containerStyle?: React.CSSProperties;
  barHeight: string;
  fillColor: string;
  tailColor: string;
};
const SliderBase = ({ containerRef, containerStyle, barHeight, fillColor, tailColor, ...props }: SliderBaseProps) => (
  <div
    ref={containerRef}
    className="slider_container"
    style={
      {
        ...containerStyle,
        "--bar-height": barHeight,
        "--track-color": fillColor,
        "--tail-color": tailColor
      } as any
    }
  >
    <RCSlider {...props} className={classNames("slider", props.className)} />
  </div>
);

export type SliderHandleProps = {
  render: (value: number) => ReactElement;
  width: number;
};
type SliderWithCustomHandleProps = Omit<SliderBaseProps, "containerRef" | "handleRender"> & {
  handle: SliderHandleProps;
};
const SliderWithCustomHandle = ({ handle, ...props }: SliderWithCustomHandleProps) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const handleRender = React.useCallback(
    (origin: React.ReactElement<React.HTMLAttributes<HTMLDivElement>>, args: { value: number }) => {
      return (
        <div {...origin.props}>
          <div
            className="custom_handle"
            style={{ transform: `translateY(calc(${props.barHeight} / 2 - 50%))`, width: handle.width }}
          >
            {handle.render!(args.value)}
          </div>
        </div>
      );
    },
    [handle.render, handle.width, props.barHeight]
  );

  React.useLayoutEffect(() => {
    const handleEl = ref.current!.querySelector<HTMLDivElement>(".custom_handle")!;
    ref.current!.style.height = `${handleEl.offsetHeight}px`;

    const left = ref.current!.querySelector<HTMLDivElement>(".rc-slider-track")!;
    left.style.marginLeft = `${-handle.width / 2}px`;

    const right = ref.current!.querySelector<HTMLDivElement>(".rc-slider-rail")!;
    right.style.transform = `translateX(${handle.width / 2}px)`;
  }, [handle.width]);

  return (
    <SliderBase
      containerRef={ref}
      {...props}
      containerStyle={{ paddingLeft: handle.width / 2, paddingRight: handle.width / 2 }}
      handleRender={handleRender}
    />
  );
};

export type SliderProps = Omit<SliderBaseProps, "containerRef" | "handleRender"> & {
  handle?: SliderHandleProps;
};
const Slider = ({ handle, ...props }: SliderProps) => {
  if (handle) {
    return <SliderWithCustomHandle {...props} handle={handle} />;
  }
  return <SliderBase {...props} />;
};
export default Slider;

export const preload = () => {}; // RCSlider.preload;
